module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectCamera":"Select camera"}}')
  delete Component.options._Ctor
}
